import { render, staticRenderFns } from "./drugList.vue?vue&type=template&id=0161db24"
import script from "./drugList.vue?vue&type=script&lang=js"
export * from "./drugList.vue?vue&type=script&lang=js"
import style0 from "./drugList.vue?vue&type=style&index=0&id=0161db24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports